import React, { useState } from 'react';
import { Button, Input, Space, Typography, Alert, message } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import api from '../utils/api';

const { Text } = Typography;
const LABEL = {
  add_expense: 'Kharcha jodna', add_income: 'Income jodna', assign_task: 'Task dena',
  send_email: 'Mail bhejna', update_song: 'Gaane ki details bharna',
};

export const downloadAiFile = (file) => {
  if (!file?.data) return;
  const bin = atob(file.data);
  const buf = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) buf[i] = bin.charCodeAt(i);
  const url = URL.createObjectURL(new Blob([buf], { type: file.mime || 'application/octet-stream' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = file.name || 'ai-file';
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
};

// Confirm card for a dashboard action the AI planned from a chat message. Nothing runs before "Haan".
export default function AiPlanCard({ plan }) {
  const [params, setParams] = useState(plan.params || {});
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      const res = await api.post('/ai/run', { action: plan.action, params });
      setState({ ok: true, text: res.data?.message || 'Ho gaya' });
    } catch (err) {
      message.error(err.response?.data?.error || 'Kaam nahi ho paaya');
    }
    setBusy(false);
  };

  if (state) return <Alert type="success" showIcon message={state.text} style={{ marginTop: 8 }} />;
  if (state === false) return null;
  return (
    <div style={{ marginTop: 8, padding: 10, border: '1px solid #fde68a', background: '#fffbeb', borderRadius: 10 }}>
      <Text strong>{LABEL[plan.action] || plan.action}</Text>
      {Object.entries(params).filter(([k]) => k !== 'assigned_to').map(([k, v]) => (
        <div key={k} style={{ marginTop: 6 }}>
          <Text type="secondary" style={{ fontSize: 11 }}>{k}</Text>
          <Input size="small" value={v ?? ''} onChange={e => setParams(p => ({ ...p, [k]: e.target.value }))} />
        </div>
      ))}
      {plan.missing?.length > 0 && <Alert type="warning" showIcon style={{ marginTop: 8 }} message={'Missing: ' + plan.missing.join(', ')} />}
      <Space style={{ marginTop: 10 }}>
        <Button size="small" type="primary" icon={<CheckCircleOutlined />} loading={busy} onClick={run}>Haan, kar do</Button>
        <Button size="small" onClick={() => setState(false)}>Nahi</Button>
      </Space>
    </div>
  );
}
